const ACTION_PREFIX = "[Payment]";
export const CORE_PAYMENT_ACTION_TYPE = {
	close: `${ACTION_PREFIX} Close`,
};
